// The same verb accompanies E, click and touch. Never promise an unavailable action.
export function interactionVerb(id='',lang='fr',stage='',kind='target'){
 const en=lang==='en';
 if(kind==='return')return en?'Return':'Remettre';
 if(kind==='place'||id.startsWith('slot:'))return en?'Place':'Poser';
 if(id==='light-switch')return en?'Turn on':'Allumer';
 if(['van-door','house-door','toolbox'].includes(id))return en?'Open':'Ouvrir';
 if(id.startsWith('item:')||id.startsWith('drop:'))return en?'Take':'Prendre';
 if(id==='mentor')return stage==='collect'?(en?'Check the kit':'Valider le kit'):(en?'Talk':'Parler');
 if(id==='screw')return en?'Fasten':'Visser';
 return en?'Use':'Utiliser';
}
